import { assign } from 'lodash';

export const LOCALE_NAME_REGEX: RegExp = (/^([a-z]{2})(?:-([A-Z][A-Z]))?$/);

export type Locale = {
    lang: string,
    country: string,
    toString: () => string
};

/*
"": {
    "project-id-version": "TS.InternetSales.Static",
    "report-msgid-bugs-to": "",
    "pot-creation-date": "2021-03-25 15:21-0400",
    "po-revision-date": "2021-05-05 08:38-0400",
    "last-translator": "Peter Perron <peter.perron@solutionstlm.com>",
    "language-team": "French <http://example.com/projects/internet-sales-30/internet-sales-20-is3-static/fr/>",
    "language": "fr",
    "mime-version": "1.0",
    "content-type": "text/plain; charset=UTF-8",
    "content-transfer-encoding": "8bit",
    "plural-forms": "nplurals=2; plural=n > 1;",
    "x-generator": "Poedit 2.4.2"
},
"# d’abonné ici": [
    null,
    "# d’abonné ici"
],
*/
export type Dict = { [key:string]: DictInformation | Array<string | null> };

export type DictInformation = {
    "project-id-version": string,
    "report-msgid-bugs-to": string,
    "pot-creation-date": string,
    "po-revision-date": string,
    "last-translator": string,
    "language-team": string,
    "language": string,
    "mime-version": string,
    "content-type": string,
    "content-transfer-encoding": string,
    "plural-forms": string,
    "x-generator": string
};

export function getDictInformation(dict: Dict): DictInformation {
    return dict[""] as DictInformation;
}

/**
 * Parses a locale code string to an object in the following format: { lang: 'fr', country: 'CA', toString: formatFunction }
 *
 * @param localeStr A locale code string. Ex.: "fr-CA" or "en-US"
*/
export function parseLocale(localeStr: string): Locale | null {
    const result = LOCALE_NAME_REGEX.exec(localeStr);
    if(result == null) return null;
    const lang = result[1];
    const country = result[2];

    return {
        lang: lang,
        country: country,
        toString: () => `${lang}-${country}`
    };
}

export function parseLang(localeStr: string): string | null {
    const r = parseLocale(localeStr);
    return r != null ? r.lang : null;
}

export function mergeDictionaries(srcDict: Dict, overwriteWithDict: Dict): Dict {
    return assign({}, srcDict, overwriteWithDict);
}

